import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthStoreService } from './core/auth-store.service';
import { NavComponent } from './nav/nav';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App {
  private readonly authStore = inject(AuthStoreService);
  private readonly router = inject(Router);
  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  protected readonly title = signal('frontend');
  protected readonly sidebarMode = computed<boolean>(() => {
    const url = this.currentUrl() ?? '';
    return this.authStore.canAccessOrganizationApp() && url !== '/' && !url.startsWith('/login');
  });
}
